import React, { useContext, useMemo } from 'react';
import { svgSprite } from '../../../hybrid/wrappers';
import { dataSender } from '../../../common/utils/router';
import UserContext, { UserProfileContext } from '../../../common/utils/getContext';
import Page from '../Pages/Pages';
import { useWindowDimensions } from '../../../common/utils/windowDimensions';
import { t } from '../../../common/components/T';
import { LangContext } from '../../../common/decorators/Language';
import css from './Pagination.module.scss';
import classnames from 'classnames';
import { generateCompStylers } from '../../../common/utils/styles';

const Pagination = ({
    meta,
    links,
    setViewData,
    setTableData,
    convertData,
    setUrl,
    gridStyles,
    smallPagination,
    token,
    filter
}) => {
    const { translation } = useContext(LangContext) || {};
    const { adminPage } = useContext(UserProfileContext);
    const widthDimensions = useWindowDimensions();
    const screenWidth = useMemo(() => widthDimensions > 768, [widthDimensions]);
    const { userToken, setAlertData, lang, localization, display_country } = useContext(UserContext);
    const paginationUrlBlank = useMemo(() => links.first.replace(/\d+$/, ''), [links.first]);

    const pagination = async (url) => {
        let newUrl = url;

        if (Array.isArray(filter?.['paginationExcludeParams']) && filter?.['paginationExcludeParams']?.length) {
            const parsedUrl = new URL(newUrl);
            filter?.['paginationExcludeParams'].forEach((filterParam) => {
                parsedUrl.searchParams.delete(filterParam);
            });
            newUrl = parsedUrl.href;
        }

        await dataSender(
            newUrl,
            'GET',
            false,
            (response) => {
                setAlertData(null);
                const sendData = convertData ? convertData(response.data, adminPage) : response.data;
                if (setViewData) {
                    setViewData((pre) => {
                        return { ...pre, tbody: sendData };
                    });
                } else {
                    setTableData(sendData);
                }
                setUrl && setUrl(url);
            },
            (data) => {
                if (data.message) {
                    setAlertData({ type: 'error', cont: data?.message });
                } else {
                    setAlertData({ type: 'error', cont: data?.false });
                }
            },
            token || userToken,
            lang,
            filter?.currency || localization.currency,
            false,
            false,
            display_country && display_country !== '<SELECT_ALL>' && !!Number(display_country) ? { 'Display-Country': '1' } : null
        );
    };
    const { stylers, classes } = generateCompStylers(gridStyles);
    return screenWidth && !smallPagination ? (
        <div
            style={stylers.paginationWrapper}
            className={gridStyles?.paginationWrapper ? classes.paginationWrapper : css.paginationWrapper}
        >
            <div
                className={classnames(css.paginationArrows)}
                onClick={() => meta.current_page !== 1 && pagination(`${paginationUrlBlank}${meta.current_page - 1}`)}
            >
                <div>
                    {' '}
                    {svgSprite('angle-left', {
                        className: css.paginationArrowsItem
                    })}{' '}
                </div>
            </div>
            <div className={css.paginationBlock}>
                <Page
                    metaCurrentPage={meta.current_page}
                    pagination={pagination}
                    paginationUrlBlank={paginationUrlBlank}
                    metaLastPage={meta?.last_page}
                />
            </div>
            <div
                className={classnames(css.paginationArrows)}
                onClick={() =>
                    meta.current_page !== meta.last_page && pagination(`${paginationUrlBlank}${meta.current_page + 1}`)
                }
            >
                <div>
                    {' '}
                    {svgSprite('angle-right', {
                        className: css.paginationArrowsItem
                    })}{' '}
                </div>
            </div>
        </div>
    ) : (
        <div
            style={stylers.paginationWrapperMobile}
            className={!!gridStyles?.paginationWrapperMobile ? classes.paginationWrapperMobile : css.paginationWrapperMobile}
        >
            <div>
                <p className={css.paginationBlockMobile}>
                    {meta.from} - {meta.to} {t('of', 'из', 'all', translation)} {meta.total}
                </p>
            </div>
            <div className={css.paginationArrowsMobileWrap}>
                <div
                    className={classnames(css.paginationArrowsMobile)}
                    onClick={() => meta.current_page !== 1 && pagination(`${paginationUrlBlank}${meta.current_page - 1}`)}
                >
                    <div>
                        {' '}
                        {svgSprite('angle-left', {
                            className: css.paginationArrowsItem
                        })}{' '}
                    </div>
                </div>
                <div
                    className={classnames(css.paginationArrowsMobile)}
                    onClick={() =>
                        meta.current_page !== meta.last_page && pagination(`${paginationUrlBlank}${meta.current_page + 1}`)
                    }
                >
                    <div>
                        {' '}
                        {svgSprite('angle-right', {
                            className: css.paginationArrowsItem
                        })}{' '}
                    </div>
                </div>
            </div>
        </div>
    );
};
export default Pagination;
